/**
 * login模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const user = {
  // 登陆接口
  login (params) {
    return $http.post(`${global.API_URL}/sme/user/login`, params)
  },
  // 注册接口
  register (params) {
    return $http.post(`${global.API_URL}/sme/user/register`, params)
  },
  // 验证邮箱，发送修改密码验证码接口
  sendVerificationCode (params) {
    return $http.post(`${global.API_URL}/sme/user/sendVerificationCode`, params)
  },
  // 确认验证码接口
  nextStep (params) {
    return $http.post(`${global.API_URL}/sme/user/nextStep`, params)
  },
  // 修改密码接口
  changePassword (params) {
    return $http.post(`${global.API_URL}/sme/user/changePassword`, params)
  },
  // 登出接口
  logout (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/user/logout`, param)
  },
  // 编辑账户
  updateUser (params) {
    return $http.post(`${global.API_URL}/sme/user/update`, params)
  },
  // 账户列表分页
  pageUser (params) {
    return $http.post(`${global.API_URL}/sme/user/page`, params)
  },
  // 账户删除
  deleteUser (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/user/delete`, param)
  },
  // 查询所有经办人
  selectAgent(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/selectAgent`,param);
  },
  // 查询角色
  selectUser (id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/user/select`, param)
  },
  //查询角色
  queryRole(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryRole`,param);
  },
  //查询当前组下所有用户
  selectQueryUsersByGroupId(params){
    return $http.post(`${global.API_URL}/sme/user/queryUsersByGroupId`,params);
  },
  //查询当前用户下所有用户
  selectQueryUsersByUserName(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryUsersByUserName`,param);
  },
  //查询当前用户
  queryGroupByUser(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryGroupByUser`, param);
  },
  //报警联系人用户下拉框
  queryAlertRuleByUser(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryAlertRuleByUser`, param);
  },
  //查询用户联系信息
  queryUserContactInformation(id, params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryUserContactInformation`, param);
    return $http.post(`${global.API_URL}/sme/user/queryGroupByUser`,param);
  },
  //切换语言
  changeLanguage(params){
    return $http.post(`${global.API_URL}/sme/user/changeLanguage`,params);
  },
  //查询当前公司用户
  queryUserByCompanyId(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryUserByCompanyId`, param);
  },
  //查询运维用户
  getOperationUsers(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/getOperationUsers`, param);
  },
  // 根据部门获取职务列表
  listPositionByDepartment(id, params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/listPositionByDepartment`, param);
  },
  // 查询注册相关的信息
  listRegisterInformation () {
    return $http.post(`${global.API_URL}/sme/user/listRegisterInformation`);
  },
  //运维工程师
  getUserByDepartment (params) {
    return $http.post(`${global.API_URL}/sme/user/getUserByDepartment`, params)
  },
  //查询版本号
  getVersion(params) {
    return $http.post(`${global.API_URL}/sme/user/getVersion`,params);
  },
  //重置密码
  reset(params) {
    return $http.post(`${global.API_URL}/sme/user/reset`,params);
  },
  //检查重置密码是否还有机会
  checkPasswordChangesAllowed(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/checkPasswordChangesAllowed`, param);
  },
  //查询处理人
  queryHandlerByCompanyId(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/queryHandlerByCompanyId`, param);
  },
  // 注册页面职位
  listPositionByDepartmentRegister(params) {
    return $http.post(`${global.API_URL}/sme/user/listPositionByDepartmentRegister`,params);
  },
  // 注册页面部门
  listDepartmentRegister(id ,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/user/listDepartmentRegister`, param);
  },
  // 验证手机号是否可以发送短信
  phoneVerify(params){
    return $http.post(`${global.API_URL}/sme/user/phoneVerify`,params);
  },
  // 发送短信验证码
  sendSmsCode(params){
    return $http.post(`${global.API_URL}/sme/user/sendSmsCode`,params);
  },
  // 验证码校验
  codeVerify(params){
    return $http.post(`${global.API_URL}/sme/user/codeVerify`,params);
  },
  // 切换系统接口
  canChangeSystem(params){
    return $http.post(`${global.API_URL}/sme/user/canChangeSystem`,params);
  },
};

export default user



// WEBPACK FOOTER //
// ./src/api/user.js